module.exports = __webpack_public_path__ + "static/menu_icon_dofinansowania-e19c3641d69c45bd68bfb6e0f10b38b0.png";